const MTR_STRUCT_MAIN_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
  remark: '備註',
};

const MTR_STRUCT_SUB_FIELD_LABELS = {
  mtrStructMainId: '主分類',
  code: '代號',
  name: '名稱',
  remark: '備註',
};

export {
  MTR_STRUCT_MAIN_FIELD_LABELS,
  MTR_STRUCT_SUB_FIELD_LABELS,
};
